import api from '@api';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const fetchPaymentInfo = createAsyncThunk(
    'payment-info/fetchPaymentInfo',
    api.ppm.payment.getCurrentPaymentInfo
);
